import React, { createContext, useEffect, useState } from 'react'
import Palette from 'Constants/Palette'

import SetCookie from 'Utilities/CookieUtilties/SetCookie'
import CookieReader from 'Utilities/CookieUtilties/CookieReader'

const lightTheme = {
    isLoading: false,
    name: 'Light',
    theme: 'light',
    inverse: 'dark',
    background_color: Palette.light,
    inverse_background_color: Palette.dark,
    content_color: Palette.dark,
    inverse_content_color: Palette.light,
    background_modifier: 'shade', // shade adds black
    inverse_background_modifier: 'tint', // tint adds white
    intent: {
        positive: {
            color: Palette.positive,
            content_color: Palette.light
        },
        negative: {
            color: Palette.negative,
            content_color: Palette.light
        },
        action: {
            color: Palette.action,
            content_color: Palette.light
        },
        warning: {
            color: Palette.warning,
            content_color: Palette.dark
        },
        subdued: {
            color: Palette.light,
            content_color: Palette.dark
        },
        lingerie: {
            color: Palette.lingerie,
            content_color: Palette.dark
        },
        facade: {
            color: Palette.facade,
            content_color: Palette.dark
        },
        disabled: {
            color: Palette.disabled,
            content_color: Palette.dark
        }
    },
    brand: {
        primary: {
            color: Palette.purple_reign,
            content_color: Palette.light
        },
        secondary: {
            color: Palette.speedway_yellow,
            content_color: Palette.dark
        },
        secondarypalette_orange: {
            color: Palette.speedway_orange,
            content_color: Palette.dark
        },
        secondarypalette_purple: {
            color: Palette.speedway_purple,
            content_color: Palette.light
        },
        secondarypalette_blue: {
            color: Palette.speedway_blue,
            content_color: Palette.light
        },
        disabled: {
            color: Palette.disabled,
            content_color: Palette.dark
        },
        secondarypalette_black: {
            color: Palette.kick_asphalt,
            content_color: Palette.light
        }
    }
}


const darkTheme = {
    isLoading: false,
    name: 'Dark',
    theme: 'dark',
    inverse: 'dark',
    background_color: Palette.dark,
    inverse_background_color: Palette.dark,
    content_color: Palette.light,
    inverse_content_color: Palette.light,
    background_modifier: 'tint', // tint adds white
    inverse_background_modifier: 'tint', // shade adds black
    intent: {
        positive: {
            color: Palette.positive_dark,
            content_color: Palette.light
        },
        negative: {
            color: Palette.negative,
            content_color: Palette.light
        },
        action: {
            color: Palette.action,
            content_color: Palette.light
        },
        warning: {
            color: Palette.warning,
            content_color: Palette.dark
        },
        subdued: {
            color: Palette.subdued,
            content_color: Palette.light
        },
        facade: {
            color: Palette.facade,
            content_color: Palette.dark
        },
        disabled: {
            color: Palette.disabled,
            content_color: Palette.dark
        }
    },
    brand: {
        primary: {
            color: Palette.purple_reign,
            content_color: Palette.light
        },
        secondary: {
            color: Palette.speedway_yellow,
            content_color: Palette.dark
        },
        secondarypalette_orange: {
            color: Palette.speedway_orange,
            content_color: Palette.dark
        },
        secondarypalette_purple: {
            color: Palette.speedway_purple,
            content_color: Palette.light
        },
        secondarypalette_blue: {
            color: Palette.speedway_blue,
            content_color: Palette.light
        },
        disabled: {
            color: Palette.disabled,
            content_color: Palette.dark
        },
        secondarypalette_black: {
            color: Palette.light,
            content_color: Palette.kick_asphalt
        }
    }
}

const ThemeContext = createContext()

const speedwayThemes = {
    Light: lightTheme,
    Dark: darkTheme
}

const ThemeProvider = ({ children, value }) => {
    var cookieTheme = CookieReader('smi_theme')

    if (cookieTheme == null) {
        value = typeof (value) !== 'undefined' ? value : speedwayThemes.Light
        SetCookie("smi_theme", 'light', 365);
    } else if (cookieTheme == 'light') {
        value = speedwayThemes.Light
    } else if (cookieTheme == 'dark') {
        value = speedwayThemes.Dark
    } else {
        value = typeof (value) !== 'undefined' ? value : speedwayThemes.Light
        SetCookie("smi_theme", 'light', 365);
    }

    const [themeContext, setThemeContext] = useState(value)


    const toggleTheme = () => {
        if (themeContext.theme == 'light') {
            SetCookie("smi_theme", 'dark', 365)
            setThemeContext(speedwayThemes.Dark)
        } else if (themeContext.theme == 'dark') {
            SetCookie("smi_theme", 'light', 365)
            setThemeContext(speedwayThemes.Light)
        } else {
            SetCookie("smi_theme", 'light', 365)
            setThemeContext(speedwayThemes.Light)
        }

    }

    useEffect(() => {

        window.addEventListener("pageshow", () => setIsLoading(false));

    }, [])

    const setIsLoading = (isLoading) => {
        setThemeContext(state => {
            return {
                ...state,
                isLoading: isLoading
            }
        })
    }


    return (
        <ThemeContext.Provider value={{
            toggleTheme,
            setIsLoading,
            ...themeContext
        }}>
            {children}
        </ThemeContext.Provider>
    )
}

const ThemeConsumer = ThemeContext.Consumer

export { ThemeProvider, ThemeConsumer, ThemeContext, speedwayThemes }
